class DesertTumblerCustomization extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('change', () => this.update(), { signal: this.controller.signal });
    this.addEventListener('input', () => this.update(), { signal: this.controller.signal });
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); }
  get mode() { return this.querySelector('[data-customization-mode]'); }
  get feeVariant() { return this.mode?.selectedOptions[0]?.dataset.feeVariant || ''; }
  update() {
    const mode = this.mode;
    const textFields = this.querySelector('[data-text-fields]');
    const logoFields = this.querySelector('[data-logo-fields]');
    const text = this.querySelector('[data-custom-text]');
    const logo = this.querySelector('[data-custom-logo]');
    const status = this.querySelector('[data-customization-status]');
    if (!mode || !textFields || !logoFields || !text || !logo || !status) return;
    const placementFields = this.querySelector('[data-placement-fields]');
    if (placementFields) placementFields.hidden = placementFields.disabled = mode.value === 'None';
    const needsText = mode.value === 'Text' || mode.value === 'Text + logo';
    const needsLogo = mode.value === 'Logo' || mode.value === 'Text + logo';
    textFields.hidden = textFields.disabled = !needsText;
    logoFields.hidden = logoFields.disabled = !needsLogo;
    text.setCustomValidity(needsText && !text.value.trim() ? this.dataset.missing : '');
    const file = logo.files?.[0];
    let uploadError = '';
    if (needsLogo) {
      if (!file) uploadError = this.dataset.uploadMissing;
      else if (file.size > 5 * 1024 * 1024) uploadError = this.dataset.fileSize;
      else if (!['image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(file.type)) uploadError = this.dataset.fileType;
    }
    logo.setCustomValidity(uploadError);
    const unavailable = mode.value !== 'None' && !this.feeVariant;
    mode.setCustomValidity(unavailable ? this.dataset.feeMissing : '');
    status.textContent = unavailable ? this.dataset.feeMissing : '';
  }
  validate() {
    this.update();
    return this.closest('form')?.reportValidity() ?? false;
  }
  prepareFormData(original) {
    if (this.mode?.value === 'None') return original;
    if (!this.feeVariant) throw new Error(this.dataset.feeMissing);
    const result = new FormData();
    for (const [name, value] of original.entries()) {
      if (name === 'id' || name === 'quantity' || name === 'selling_plan') {
        result.append(`items[0][${name}]`, value);
      } else if (name.startsWith('properties[')) {
        result.append(`items[0][properties]${name.slice('properties'.length)}`, value);
      } else {
        result.append(name, value);
      }
    }
    const quantity = original.get('quantity') || '1';
    result.set('items[0][quantity]', quantity);
    result.set('items[1][id]', this.feeVariant);
    result.set('items[1][quantity]', quantity);
    result.set('items[1][parent_id]', original.get('id'));
    return result;
  }
}
if (!customElements.get('desert-tumbler-customization')) customElements.define('desert-tumbler-customization', DesertTumblerCustomization);
